<template>
  <div class="login-form-home text-align-left">
    <div class="login-form-wrapper">
      <div class="bp-logo">
        <img src="@/assets/images/logos/BP.png" alt="logo">
        <p class="app-name">{{ $t('OUTER_PAGES.common.player')}}</p>
        <div class="logo-text">{{ $t('OUTER_PAGES.common.subheading')}}</div>
      </div>
      <form v-loading-form="loadingForm" class="form" name="loginForm" novalidate @submit.prevent="onLoginFormSubmitted">
        <div class="text-center loginForm loginForm-default">
          <div class="error-wrapper-table">
            <div class="error-wrapper">
              <div class="error server-error" v-if="serverErrors && showLoginForm">
                <img src="@/assets/images/icons/error-icon.png" alt="error">
                  {{ $t('OUTER_PAGES.loginPage.otherError')}}
              </div>
              <div class="error server-error" v-if="notRegistered && showLoginForm">
                <img src="@/assets/images/icons/error-icon.png" alt="error">
                  {{ $t('OUTER_PAGES.intergrations.invalidCredentials')}}
              </div>
              <div class="error" v-show="(errors.has('email') && formSubmitted)">
                <img src="@/assets/images/icons/error-icon.png" alt="error">
                  {{ errors.first('email') }}
                </div>
                <div class="error" v-show="(errors.has('password') && formSubmitted)">
                  <img src="@/assets/images/icons/error-icon.png" alt="error">
                    {{ errors.first('password') }}
                </div>
                <div class="error server-error" v-if="accessCodeExpired && showAccessCode">
                  <img src="@/assets/images/icons/error-icon.png" alt="error">
                    {{ $t('OUTER_PAGES.intergrations.accessCodeExpired')}}
                </div>
              </div>
            </div>
            <div class="go-back" @click="goBackToLogin" v-if="showAccessCode || childPicker"><img class="back-icon" src="@/assets/images/icons/arrow-left-icon.png" alt="back"> {{ $t('OUTER_PAGES.intergrations.back')}}</div>
            <div class="form-group inputLogin">
              <input
                v-if="showLoginForm"
                id="email"
                :class="{'error-input': (errors.has('email') && formSubmitted)}"
                @input="serverErrors = false"
                type="email"
                class="form-control"
                :placeholder="$t('OUTER_PAGES.loginPage.email')"
                name="email"
                v-model="email"
                v-validate="'required|email'">
              <input
                v-if="showLoginForm"
                id="password"
                type="password"
                :class="{'error-input': (errors.has('password') && formSubmitted)}"
                class="form-control"
                :placeholder="$t('OUTER_PAGES.loginPage.password')"
                v-model="password"
                v-validate="'required|min:8|max:50'"
                name="password">

                <div class="team-filter-wrapper" v-if="childPicker">
                  <b-dropdown id="ddown1" class="btn-group dropdown calendar-filter-btn">
                    <template slot="button-content" >
                      <template >
                        <span class="text-ellipsis-overflow">{{selectedPlayer === '' ? 'Select Player' : selectedPlayer}}</span>
                      </template>
                    </template>

                    <template>
                      <b-dropdown-item
                        v-for="(player, i) in childrenForIntegration"
                        :key="i"
                        @click.prevent="onSelectPlayer(player)"
                        class="active">

                        <span class="text-ellipsis-overflow">{{player.firstName + ' ' + player.lastName}}</span>
                      </b-dropdown-item>
                    </template>
                  </b-dropdown>
                </div>
  
                <div class="integrations-code" v-if="showAccessCode">
                  <input
                    v-if="!childrenForIntegration"
                    id="accessCode"
                    type="text"
                    :class="{'error-input': (errors.has('password') && formSubmitted)}"
                    class="form-control"
                    :placeholder="$t('OUTER_PAGES.intergrations.placeholder')"
                    v-model="accessCode"
                    v-validate="'required|min:8|max:50'"
                    name="code"
                    readonly>
                    <button v-if="!childrenForIntegration" class="btn btn-type-1" @click.prevent="copyToClipboard('accessCode')">{{ $t('OUTER_PAGES.intergrations.copy')}}</button>

                    <input
                    v-if="childrenForIntegration"
                    id="accessCodeForChild"
                    type="text"
                    :class="{'error-input': (errors.has('password') && formSubmitted)}"
                    class="form-control"
                    :placeholder="$t('OUTER_PAGES.intergrations.placeholder')"
                    v-model="accessCodeForChild"
                    v-validate="'required|min:8|max:50'"
                    name="code"
                    readonly>
                  <button v-if="childrenForIntegration" class="btn btn-type-1" @click.prevent="copyToClipboard('accessCodeForChild')">{{ $t('OUTER_PAGES.intergrations.copy')}}</button>
                </div>
            </div>
          </div>
          <div class="text-center loginStructure">
            <button type="submit" class="btn buttonOnLogin btn-type-1" v-if="showLoginForm">
              <span class="button-content">{{ $t('OUTER_PAGES.intergrations.submit')}}</span>
            </button>
            <div class="note-messages" v-if="showLoginForm">* {{ $t('OUTER_PAGES.intergrations.noteMsg')}}</div>
            <div class="note-messages" v-if="showAccessCode">* {{ $t('OUTER_PAGES.intergrations.accessCodeExpires')}}</div>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
import STATUS_CODES from '@/common/statusCodes'
import { mapActions, mapGetters } from 'vuex'
import { INTEGRATIONS, INTEGRATIONS_SELECT_CHILD } from '@/store/action.types'

export default {
  name: 'Integrations',
  data () {
    return {
      email: '',
      password: '',
      accessCode: '',
      accessCodeForChild: '',
      serverErrors: false,
      formSubmitted: false,
      loadingForm: false,
      notRegistered: false,
      showAccessCode: false,
      showLoginForm: true,
      childPicker: false,
      selectedPlayer: '',
      accessCodeExpired: false
    }
  },
  computed: {
    ...mapGetters([
      'childrenForIntegration'
    ]),
  },
  methods: {
    ...mapActions({
      integrationsAction: INTEGRATIONS,
      selectChildAction: INTEGRATIONS_SELECT_CHILD
    }),
    onLoginFormSubmitted () {
      this.$validator.validateAll().then(result => {
        this.loadingForm = true
        this.formSubmitted = true
        if (result) {
          this.integrationsAction({
            email: this.email,
            password: this.password
          })
            .then((data) => {
              window.clearTimeout(this.timeout)
              if (data.data) {
                this.accessCode = data.data.otp
                this.accountId = data.data.accountId
                if (data.data.children) {
                  this.childPicker = true
                  this.showLoginForm = false
                } else {
                  this.showAccessCode = true
                  this.showLoginForm = false
                  let context = this
                  this.timeout = setTimeout(function(){ 
                  context.accessCode = ""
                  context.accessCodeExpired = true
                  }, 60000);
                }
              } 
              else {
                if (data.status.code === STATUS_CODES.BP_401) {
                  this.notRegistered = true;
                } else {
                  this.serverErrors = true
                  this.notRegistered = false;
                }
                  this.loadingForm = false;
              }
            })
            .catch((error) => {
              this.serverErrors = true
              this.loadingForm = false;
            })
        } else {
          this.loadingForm = false
        }
      })
    },
    goBackToLogin() {
      this.serverErrors = false;
      this.notRegistered = false;
      if (this.showAccessCode && this.childrenForIntegration && !this.accessCodeExpired) {
        this.childPicker = true
      } else {
        this.showLoginForm = true
        this.childPicker = false
        this.selectedPlayer = ''
      }
        this.loadingForm = false
        this.showAccessCode = false
        this.accessCodeExpired = false
    },
    onSelectPlayer(player) {
      window.clearTimeout(this.timeout)
      this.selectedPlayer = player.firstName + ' ' + player.lastName
      this.selectChildAction({
        childId: player.id,
        otp: this.accessCode,
        accountId: this.accountId
      })
        .then((data) => {
          let context = this;
          this.accessCodeForChild = data.otp
          this.childPicker = false
          this.showAccessCode = true
          this.timeout = setTimeout(function(){ 
            context.accessCodeForChild = ""
            context.accessCodeExpired = true
          }, 60000);
        })
        this.accessCodeExpired = false
    },
    copyToClipboard(id) {
      let copySample = document.querySelector(`#${id}`);
      copySample.select();
      document.execCommand('copy');
    }
  }
}
</script>

<style lang="scss" scoped>
  .integrations-code {
    display: flex;
    margin-top: 20px;
    width: 100%;

    .btn-type-1 {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    .form-control {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  
  .go-back {
    text-align: left;
    cursor: pointer;
    color: $tangerine;
    float: left;
    margin-bottom: 15px;
    .back-icon {
      margin-bottom: 2px;
    }
  }

  .note-messages {
    text-align: left;
    margin-bottom: 15px;
    font-size: 14px;
  }
</style>
